import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RequestError } from '../../../interfaces/error.interface';
import { ValorizationData } from '../interfaces/valorization.interface';
import { GetValorizationResponse } from '../interfaces/get-valorization';
import { PostValorizationResponse } from '../interfaces/post-valorization';

export interface ValorizationState {
  valorization: ValorizationData | null;
  loading: boolean;
  errorCode: number | null;
}

const initialState: ValorizationState = {
  valorization: null,
  loading: false,
  errorCode: null,
};

const valorizationSlice = createSlice({
  name: 'valorization',
  initialState,
  reducers: {
    getValorizationInitApiAction: (state) => {
      state.loading = true;
      state.errorCode = null;
    },
    getValorizationSuccessApiAction: (
      state,
      action: PayloadAction<GetValorizationResponse>
    ) => {
      state.loading = false;
      state.valorization = action.payload;
      state.errorCode = null;
    },
    getValorizationFailureApiAction: (
      state,
      action: PayloadAction<RequestError>
    ) => {
      state.loading = false;
      state.errorCode = action.payload.errorCode;
    },
    postValorizationInitApiAction: (state) => {
      state.loading = true;
      state.errorCode = null;
    },
    postValorizationSuccessApiAction: (
      state,
      action: PayloadAction<PostValorizationResponse>
    ) => {
      state.loading = false;
      state.valorization = action.payload;
      state.errorCode = null;
    },
    postValorizationFailureApiAction: (
      state,
      action: PayloadAction<RequestError>
    ) => {
      state.loading = false;
      state.errorCode = action.payload.errorCode;
    },
    clearValorizationAction: (state) => {
      state.valorization = null;
      state.loading = false;
      state.errorCode = null;
    },
  },
});

export const {
  getValorizationInitApiAction,
  getValorizationSuccessApiAction,
  getValorizationFailureApiAction,
  postValorizationInitApiAction,
  postValorizationSuccessApiAction,
  postValorizationFailureApiAction,
  clearValorizationAction,
} = valorizationSlice.actions;

export default valorizationSlice.reducer; 